// json压缩
export function jsonCompress(data) {
  if (Object.prototype.toString.call(data) !== "[object Object]") return
  const templatesObj = Object.create(null)
  let serial = 1
  const typeSymbolMap = {
    string: "$",
    boolean: "&",
    number: "#",
    default: "_"
  }
  function jsonTrans(origin) {
    const simplyArray = []
    const otherParams = {}
    const _arrayTemp = []
    if (!origin) return origin
    if (typeof origin !== "object") return origin
    if (Array.isArray(origin)) {
      for (let i = 0; i < origin.length; i++) {
        _arrayTemp[i] = jsonTrans(origin[i])
      }
      return _arrayTemp
    }
    Object.entries(origin).forEach(([key, value]) => {
      // appIdList节点不压缩
      // 富文本的内容压缩后解压可能会出问题，所以屏蔽掉。另外富文本后续也会提出来单独保存
      if (
        key === "clonePageLayout" ||
        key === "themeColorList" ||
        key === "appList" ||
        key === "appIdList" ||
        key === "i0" ||
        key === "appId" ||
        key === "globalStyle" ||
        key === "version" ||
        key === "isOnlyH5Template" ||
        key === "isPhoneFullScreen" ||
        key === "enableSubHead" ||
        key === "subHeadPages" ||
        (key === "d9" &&  origin.c4 === 'cxEditor') ||
        (key === "content" &&  origin.innerElement === 'cxEditor')
      ) {
        otherParams[key] = value
        return
      }
      if (typeof value !== "object") {
        // 说明是普通的值, 可以进入配对池
        const dividerSymbol = typeSymbolMap[typeof value] || "_"
        const template_key = key + dividerSymbol + value
        if (!templatesObj[template_key]) {
          templatesObj[template_key] = serial
          simplyArray.push(serial)
          serial = serial + 1
        } else {
          simplyArray.push(templatesObj[template_key])
        }
      } else if (Array.isArray(value)) {
        const isAllSimpleValue =
          value.length && value.every(item => typeof item !== "object" && typeof item === "string")
        if (isAllSimpleValue) {
          // 如果数组里面都是简单值
          const dividerSymbol = "^"
          const template_key = key + dividerSymbol + value.join("!!")
          if (templatesObj[template_key]) {
            simplyArray.push(templatesObj[template_key])
          } else {
            templatesObj[template_key] = serial
            simplyArray.push(serial)
            serial = serial + 1
          }
        } else {
          otherParams[key] = []
          for (let i = 0; i < value.length; i++) {
            otherParams[key][i] = jsonTrans(value[i])
          }
        }
      } else {
        // 说明是对象
        otherParams[key] = jsonTrans(value)
      }
    })
    return {
      simplyArray,
      ...otherParams
    }
  }
  // 将version提取出来
  const version = data.version
  delete data.version
  return {
    templates: templatesObj,
    data: jsonTrans(data),
    version: version
  }
}
// json解压缩
export function jsonCompressEncode(origin) {
  // return
  const version = origin.version
  const templates = origin.templates
  if (!templates) return origin
  const templatesMap = {}
  // template反转
  Object.entries(templates).forEach(([key, value]) => {
    templatesMap[value] = key
  })
  function restore(data) {
    if (!data) return data
    if (typeof data !== "object") return data
    if (Array.isArray(data)) {
      const _temp = []
      data.forEach((item, index) => {
        _temp[index] = restore(item)
      })
      return _temp
    }
    Object.keys(data).forEach(key => {
      if (key === "simplyArray") {
        // 进行值还原
        data[key].forEach(index => {
          const keyValue = templatesMap[index]
          const reg = /(.+?)([#|$|^|&])([\s\S]*)/
          const matchResult = reg.exec(keyValue)
          if (!matchResult) return
          const key = matchResult[1]
          const divider = matchResult[2]
          const value = matchResult[3] || ""
          let targetValue = value
          if (divider === "^") {
            targetValue = value.split("!!")
          } else if (divider === "&") {
            targetValue = value === "true" ? true : false
          } else if (divider === "#") {
            targetValue = Number(value)
          }
          data[key] = targetValue
        })
        delete data.simplyArray
      } else {
        if (Array.isArray(data[key])) {
          // 如果是数组，要进行一波还原
          data[key].forEach((item, index) => {
            data[key][index] = restore(item)
          })
        } else if (typeof data[key] === "object") {
          restore(data[key])
        }
      }
    })

    return data
  }
  const result = restore(origin.data)
  result.version = version
  return result
}
